var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnvalidatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99975 13.96C1.94375 13.96 1.14375 13.128 1.14375 12.104C1.14375 11.08 1.94375 10.248 2.99975 10.248C4.07175 10.248 4.85575 11.08 4.85575 12.104C4.85575 13.128 4.07175 13.96 2.99975 13.96Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnvalidatedIcon);
export default __webpack_public_path__ + "static/media/unvalidated-icon.f02c665a69de5bad3f30d10f87c07424.svg";
export { ForwardRef as ReactComponent };